import React, { Component } from "react";
import ModalGiveAway from "../modal/modal_giveaway";

import SharingInviteView from "../../../share/sharing_invite_view";
class GiveawayInvite extends Component {
  state = { openMedia: false, openGift: false, showSharingView: false };
  render() {
    return (
      <div className="list_user" style={{ backgroundColor: "white" }}>
        <div className="pt-2 pb-2">{this.renderImage()}</div>
        <div
          style={{
            marginTop: "15px",
            marginBottom: "5px",
            marginLeft: "5%",
            marginRight: "5%",
            fontFamily: "DIN PRO Bold",
            fontSize: "12px",
            color: "#9B9B9B"
          }}
          className="pt-2"
        >
          <span
            style={{
              fontFamily: "DIN PRO Black",
              textTransform: "uppercase",
              fontSize: "22px",
              color: "black"
            }}
          >
            Add friends to enter to win
          </span>
          <br />
          <span
            style={{
              fontFamily: "DIN PRO Black",
              textTransform: "uppercase",
              fontSize: "22px",
              color: "black"
            }}
          >
            {this.props.invite_giveaway.item}
          </span>
          <br />
          Each new friend = 1 entry
        </div>
        <div>
          <button
            className="btn btn_primary btn_yaystack btn_next "
            onClick={this.handleInviteFriendButton}
            style={{ width: "50%", marginBottom: "8px", marginTop: "8px" }}
          >
            LET'S GO
          </button>
          {this.renderShareView()}
        </div>
      </div>
    );
  }

  renderImage() {
    if (this.props.invite_giveaway.type === "image") {
      return (
        <div
          style={{
            width: "100%",
            // border: "solid 1px black",
            borderRadius: "10px",
            paddingTop: "70%",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <img
            src={this.props.invite_giveaway.image_url_original}
            alt=""
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "0px",
              left: "0px",
              objectFit: "contain"
            }}
          />
        </div>
      );
    }
  }

  renderShareView() {
    if (this.state.showSharingView) {
      return (
        <SharingInviteView
          handlerInviteFriend={this.handlerInviteFriend}
          username={this.props.user.username}
        />
      );
    }
  }

  handleInviteFriendButton = event => {
    event.preventDefault();
    if (!this.props.user) {
      this.props.history.push("/profile");
      return;
    }
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };

  handlerInviteFriend = e => {
    const showSharingView = !this.state.showSharingView;
    this.setState({ showSharingView });
  };
}

export default GiveawayInvite;



// WEBPACK FOOTER //
// ./src/components/list/interface/giveaway/giveaway_invite.jsx